export default "__VITE_ASSET__YZPIef2M__"